import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import { StatusDialogProps } from './types';

// ----------------------------------------------------------------------

export default function CommentDialog({
  title,
  content,
  open,
  onClose,
  ...other
}: StatusDialogProps) {
  return (
    <Dialog fullWidth open={open} onClose={onClose} {...other}>
      <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>

      {content && (
        <DialogContent sx={{ typography: 'body2' }}> {content} </DialogContent>
      )}

      <DialogActions>
        <Button
          variant="outlined"
          color="inherit"
          onClick={onClose}
          sx={{ whiteSpace: 'nowrap' }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
